import { Injectable } from "@angular/core";
import { EditDialogService } from "@nexato/nx-core-module";
import { AbstractTaskUpdateAddressCommandCustomFlow } from "./AbstractTaskUpdateAddressCommandCustomFlow";

@Injectable({
    providedIn: 'root'
  })
export class OperatedRentalTaskUpdateAddressCommandCustomFlow extends AbstractTaskUpdateAddressCommandCustomFlow {

  constructor(
    dialogService: EditDialogService
  ) {
    super(dialogService);
   }
  
  
}